<div
  [hidden]="dataSource.data?.length"
  class="row center">
  <div class="col">
    <h2>{{ localizationConstants.REMINDERS_NO_REMINDERS_FOUND | translate }}</h2>
  </div>
</div>
<div
  [hidden]="!dataSource.data?.length"
  class="col-12 col-sm-6 col-md-3 u-mb--medium">
  <form class="c-search-form--full">
    <div class="c-input-group">
      <input
        type="text"
        name="search"
        id="input-search"
        [(ngModel)]="dataSource.filter"
        class="c-input c-input--beta"
        placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
        required />
      <input
        *ngIf="dataSource.filter"
        id="reminders-search-clear"
        (click)="dataSource.filter = ''"
        class="c-button c-button--search c-close-search c-button--search--sm"
        value="Clear" />
      <input
        *ngIf="!dataSource.filter"
        id="reminders-search"
        type="submit"
        class="c-button c-button--search c-button--search--sm"
        value="Search" />
    </div>
  </form>

  <table
    mat-table
    #countryRemindersTable
    matSort
    [dataSource]="dataSource"
    class="c-table col-12 col-md-8">
    <ng-container
      *ngFor="let col of columns"
      [matColumnDef]="col.key">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        class="c-table__column-title">
        {{ col.title | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let reminder">
        <ng-container [ngSwitch]="col.key">
          <div *ngSwitchCase="'countryName'">{{ reminder.countryName }}</div>
          <div *ngSwitchCase="'companyFullName'">
            {{ reminder.companyFullName + " " + reminder.companyId }}
          </div>
          <div *ngSwitchCase="'type'">{{ reminder.type | reminder: "type" | translate }}</div>
          <div *ngSwitchCase="'interval'">
            {{ reminder.interval | reminder: "interval" | translate }}
          </div>
          <div *ngSwitchCase="'daysBefore'">{{ reminder.daysBefore }}</div>
          <div *ngSwitchCase="'daysAfter'">{{ reminder.daysAfter }}</div>
          <div *ngSwitchCase="'to'">
            <div
              *ngFor="let item of reminder.to | split: ';'"
              class="c-chip">
              {{ item }}
            </div>
          </div>
          <div *ngSwitchCase="'cc'">
            <div
              *ngFor="let item of reminder.cc | split: ';'"
              class="c-chip">
              {{ item }}
            </div>
          </div>
          <div *ngSwitchCase="'bcc'">
            <div
              *ngFor="let item of reminder.bcc | split: ';'"
              class="c-chip">
              {{ item }}
            </div>
          </div>
          <div *ngSwitchCase="'nextRemind'">{{ reminder.nextRemind | date }}</div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="action1">
      <th
        mat-header-cell
        *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let reminder"
        class="action">
        <button
          type="button"
          class="button--sm button-primary button-block"
          (click)="onEditReminder(reminder)">
          {{ localizationConstants.BUTTON_EDIT | translate }}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="action2">
      <th
        mat-header-cell
        *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let reminder"
        class="action">
        <button
          type="button"
          class="button--sm button-secondary button-block"
          (click)="onRemoveReminder(reminder)"
          [disabled]="reminder.pending">
          <app-loading-icon *ngIf="reminder.pending"></app-loading-icon>
          <span *ngIf="!reminder.pending">{{
            localizationConstants.BUTTON_DELETE | translate
          }}</span>
        </button>
      </td>
    </ng-container>

    <tr
      matNoDataRow
      *matNoDataRow>
      <td colspan="12">
        <div class="center">
          {{ localizationConstants.TABLE_NO_RESULTS | translate }}
        </div>
      </td>
    </tr>
    <tr
      mat-header-row
      *matHeaderRowDef="columnKeysAll"></tr>
    <tr
      mat-row
      *matRowDef="let item; columns: columnKeysAll"
      class="c-table__row"></tr>
  </table>
  <div class="c-pagination--desktop">
    <div class="col-12">
      <mat-paginator
        [showFirstLastButtons]="true"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
